//types
import type { KeyedMutator, SWRConfiguration } from 'swr';
import useSWR from 'swr';

import { get } from '@/utils/client';

import type { UserMarketingType } from '@/types/userMarketingType';

import { USER_MARKETING } from '@/routes/apiEndpoints';

export type MutateUserMarketType = KeyedMutator<UserMarketingType>;

const useUserMarketing = (options?: SWRConfiguration<UserMarketingType, Error>) => {
    const {
        data: userMarket,
        mutate: mutateUserMarket,
        error: userMarketError,
        isLoading
    } = useSWR<UserMarketingType, Error>(
        USER_MARKETING,
        (url) => get(url).then((res) => res.data),
        {
            shouldRetryOnError: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            ...options
        }
    );

    return {
        userMarket,
        mutateUserMarket,
        userMarketError,
        isLoading
    };
};

export default useUserMarketing;
